import axios from 'axios';
import { Config } from '../Config';
import { userAccessToken } from "../helpers";
export const getAllPrompts = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    show_all
  } = filter;

  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let showAll = show_all ? `&show_all=${show_all}` : "";

  try {
    const response = await axios.get(`${Config.apiServerUrl}/speciality/get-speciality-prompts?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${showAll}`, 
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching specialities:', error.response?.status, error.response?.data?.detail || error.message);
    throw error;
  }
};

export const fetchSingleParams = async (
  account_id,
  location_id,
  speciality_prompt_id
) => {
  try {
    const response = await axios.get(`${Config.apiServerUrl}/speciality/get-single-speciality-prompt?account_id=${account_id}&location_id=${location_id}&speciality_prompt_id=${speciality_prompt_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const uploadPrompt = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  try {
    const response = await axios.post(`${Config.apiServerUrl}/speciality/create-speciality-prompt`, formData, 
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const updatePrompt = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  try {
    const response = await axios.put(`${Config.apiServerUrl}/speciality/update-speciality-prompt`, formData, 
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error updating file:', error);
    throw error;
  }
}

export const deletePrompt = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(`${Config.apiServerUrl}/speciality/delete-speciality-prompt?account_id=${account_id}&location_id=${location_id}}&speciality_prompt_id=${id}`, 
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
}